// Format member numbers as a Blockbuster-card-style "MEMBER #00012".
export function formatMemberNumber(n) {
  if (n === null || n === undefined) return '';
  const padded = String(n).padStart(5, '0');
  return `#${padded}`;
}
